<template>
    <EqsDataTable
        v-bind="{
            itemKey: 'id',
            items: assets,
            headers,
            column: false
        }"
    >
        <template #item.name="{ item }">
            <td :el-class="`${item.shareledger.name}-name`">
                {{ `${item.shareledger.name} (${item.shareledger.symbol})` }}
            </td>
        </template>
        <template #item.balance="{ item }">
            <td :el-class="`${item.shareledger.name}-shares`">
                {{ $currency.display(item.balance, "0,0") }}
            </td>
        </template>
        <template #item.percentage="{ item }">
            <td :el-class="`${item.shareledger.name}-percent`">
                {{ calcPercent(item.balance, item.shareledger.numberofshares) }} %
            </td>
        </template>
        <template #item.value="{ item }">
            <td :el-class="`${item.shareledger.name}-amount`">
                {{
                    $currency.displayWithCurrency(
                        item.value,
                        item.alphacode == "US" ? "USD" : "EUR"
                    )
                }}
            </td>
        </template>
    </EqsDataTable>
</template>

<script>
import { calcPercent } from "@equisafe-ui-shared/util";

export default {
    name: "MyHoldings",
    props: {
        assets: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            calcPercent,
            headers: [
                {
                    text: "",
                    value: "name"
                },
                {
                    text: this.$t("portfolio.holdings.shares"),
                    value: "balance"
                },
                {
                    text: this.$t("portfolio.holdings.percentage"),
                    value: "percentage",
                    sortable: false
                },
                {
                    text: this.$t("portfolio.holdings.value-mini"),
                    value: "value"
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped></style>
